import Popup from "components/popup/Popup";
import Portal from "elements/Portal";
import React from "react";
import { useTranslation } from "react-i18next";

interface IArchiveTaxLines {
  isOpen: boolean;
  title: string;
  onOk: () => void;
  onCancel: () => void;
}

export default function ArchiveTaxLine(props: IArchiveTaxLines) {
  const { isOpen, title, onOk, onCancel } = props;
  const { t } = useTranslation();

  return (
    <Portal isMounted={isOpen}>
      <Popup
        open={isOpen}
        type="warning"
        title={title}
        description={t("This cannot be undone.")}
        okText={t("Archive")}
        onCancel={onCancel}
        onOk={onOk}
      ></Popup>
    </Portal>
  );
}
